import { listResponseSchema } from '@/common/api/schemas.ts';
import { z } from 'zod';

export const collectorListResponseSchema = listResponseSchema(
  z.object({
    id: z.string(),
    name: z.string(),
    computerId: z.string(),
  })
);

export type CollectorListResponse = z.infer<typeof collectorListResponseSchema>;
